import { Box, Skeleton, Stack, SxProps, Typography } from "@mui/material";
import React from "react";

interface IProps<T> {
  dataSource?: T[];
  isLoading?: boolean;
  spacing?: number;
  divider?: React.ReactNode;
  sx?: SxProps;
  renderSkeleton?: (index: number) => React.ReactNode;
  placeholder?: string;
  renderItem: (item: T, index: number) => React.ReactNode;
}

const ViewList = <T,>(props: IProps<T>) => {
  function renderSkeleton() {
    return [...Array(3)].map((_, i) =>
      props.renderSkeleton ? props.renderSkeleton(i) : <Skeleton key={i} variant="rectangular" />,
    );
  }

  function renderPlaceholder() {
    return (
      <Box sx={{ pl: 0.5 }}>
        <Typography variant="placeholder">{props.placeholder ?? "Nothing here yet."}</Typography>
      </Box>
    );
  }

  function renderList() {
    return (props.dataSource ?? []).map((item, index) => props.renderItem(item, index));
  }

  return (
    <Stack sx={{ ...props.sx }} spacing={props.spacing ?? 0.5} divider={props.divider}>
      {props.isLoading
        ? renderSkeleton()
        : !props.dataSource || props.dataSource.length === 0
          ? renderPlaceholder()
          : renderList()}
    </Stack>
  );
};

export { ViewList };
